






























import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class CountDown extends Vue {
  @Prop({ default: 0 })
  private time?: number;

  @Prop({ default: 3 })
  private num?: number;

  // 传入
  @Prop({ default: true })
  private splashTime?: boolean;

  // 传入type为clock则是带闹钟
  @Prop({ default: "" })
  private type?: string;

  @Prop({ default: 14 })
  private fontSize?: number;

  @Prop({ default: "" })
  private bgColor?: string;

  @Prop({ default: "" })
  private itemColor?: string;

  private timeArr: any = [];

  private showPointSeperator(index: any) {
    if (this.type === "clock" && index > 0) {
      return ":";
    } else {
      return "";
    }
  }

  @Watch("time", { immediate: true })
  private changeTime(time: number, num: number, oldVal: number) {
    const h =
      Math.floor(time / 3600) < 10
        ? "0" + Math.floor(time / 3600)
        : Math.floor(time / 3600);
    const m =
      Math.floor((time / 60) % 60) < 10
        ? "0" + Math.floor((time / 60) % 60)
        : Math.floor((time / 60) % 60);
    const s =
      Math.floor(time % 60) < 10
        ? "0" + Math.floor(time % 60)
        : Math.floor(time % 60);
    if (this.num === 1) {
      this.timeArr = [s];
    } else if (this.num === 2) {
      this.timeArr = [m, s];
    } else {
      this.timeArr = [h, m, s];
    }
  }
}
